import React, { FC, PropsWithChildren } from 'react';

import { ROLES } from 'constants/roles';
import { useAppSelector } from 'store';
import { tokenInfoSelector } from 'store/auth/auth.selectors';

interface Props {
  role: ROLES;
}

export const RoleProtectedRoute: FC<PropsWithChildren<Props>> = ({ children, role })  => {
  const tokenInfo = useAppSelector(tokenInfoSelector);
  if (!tokenInfo?.roles.includes(role)) {
    return null;
  }
  return <>{children}</>;
};

export default RoleProtectedRoute;
